import FaqPage from '@/components/feature/FaqPage';

export default function SmQ2Page() {
  return (
    <FaqPage
      category="Subscription Management"
      categoryPath="/"
      icon="ri-refresh-line"
      title="Does my subscription automatically renew?"
      intro="Understand how subscription renewals work, when you will be charged, and how to manage or disable automatic renewal."
      sections={[
        {
          heading: 'Does my subscription renew automatically?',
          content: [
            'Yes, all subscriptions are set to automatically renew at the end of each billing cycle by default. This ensures uninterrupted access to your service.',
            'You will receive a renewal reminder email 7 days before your subscription is due to renew, giving you time to make any changes.',
          ],
        },
        {
          heading: 'When will I be charged?',
          content: [
            'You will be charged on the same date each billing cycle — the date you originally subscribed. For example, if you subscribed on the 5th of the month, you will be charged on the 5th of each subsequent month.',
            'If that date does not exist in a given month (e.g., the 31st), you will be charged on the last day of that month.',
          ],
        },
        {
          heading: 'How do I turn off automatic renewal?',
          content: [
            'To disable automatic renewal, go to Account Settings > Subscription and toggle off "Auto-Renew". Your subscription will remain active until the end of the current billing period and will not renew.',
            'You can re-enable auto-renewal at any time before your subscription expires.',
          ],
        },
        {
          heading: 'What happens if my payment fails on renewal?',
          content: [
            'If your payment fails, we will attempt to charge your payment method again over the next few days. You will receive email notifications about the failed payment.',
            'If the payment continues to fail, your subscription may be suspended. Please update your payment details in Account Settings to avoid interruption.',
          ],
        },
      ]}
    />
  );
}
